export default class SingleChoiceData {
    /**
     * 
     * @param {string} episodeId
     * @param {string} dialogId 
     * @param {string} situationId 
     * @param {string} optionId 
     * @param {number} timeToAnswer - in msecs 
     */
    constructor(episodeId, dialogId, situationId, optionId, timeToAnswer) {
        this.episodeId = episodeId;
        this.dialogId = dialogId;
        this.situationId = situationId;
        this.optionId = optionId;
        this.timeToAnswer = timeToAnswer;
    }
}
